// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { BlobQueryResponse } from "./BlobQueryResponse.common.js";
